module.exports = __webpack_public_path__ + "img/backdoor.bdce8b4d.png";